import { render } from "./Joystick.vue?vue&type=template&id=43f42e4e"
import script from "./Joystick.vue?vue&type=script&lang=js"
export * from "./Joystick.vue?vue&type=script&lang=js"

import "./Joystick.vue?vue&type=style&index=0&id=43f42e4e&lang=scss"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__